import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M19 5h-7v6l7 8zm-7 14v-8l-7 8z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9 0H5l7-8V5h7v14l-7-8v8z"
})), 'FilterBAndWTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FilterBAndWTwoTone.js
// module id = 3629
// module chunks = 2